/**
 * CLC JAVASCRIPT BOOTSTRAP
 * ==============================================================================
 * This file provides basic features and loads other JS / CSS files as necessary.
 */

/**
 * Helper functions
 */
function loadJsFile(scriptFilename) {

  //jQuery's 'getScript()' method isn't ideal since it can take a while
  //for the external file to load and be evaluated, rather set all AJAX
  //requests to be synchronous first (so other code waits for the file
  //to finish loading, then set them back to asynchronous:
  scriptUrl = _baseUrl + 'javascript/' + scriptFilename;
  jQuery.ajaxSetup({async: false});
  jQuery.getScript(scriptUrl);
  jQuery.ajaxSetup({async: true});

}


/**
 * Bootstrap functions
 */
function initializeAjax() {

  jQuery.ajaxSetup({
  
    dataType: 'json',
    error:    function(jqXHR, textStatus, errorThrown) { ajaxRequestError(jqXHR, textStatus, errorThrown) },
    timeout:  30000,
    type:     'post'
  
  });

}


/**
 * Ajax functions
 */
function ajaxRequestError(jqXHR, textStatus, errorThrown) {

  //a timeout or other error occurred (detailed in textStatus), log a warning:
  if (textStatus == 'timeout')
    console.log('ERROR: Ajax request timed out.');
  else
    console.log('ERROR: Ajax request failed.');
  
}

function ajaxRequestSend(requestData, requestTarget, requestResponder) {

  jQuery.ajax(
              _baseUrl + requestTarget,
              {
                data:    requestData,
                success: function(data, textStatus, jqXHR) { requestResponder(data, textStatus, jqXHR) }
              }
             );

}


jQuery(document).ready(function() {

  //enable jQuery's noConflict mode:
  jQuery.noConflict();
  
  //initialize the jQuery plugins:
  initializeAjax();

});